import { card_promotion_mechanics } from "@assets/constants/card_promotion_mechanics";

export const isCommonPromotion = (mechanic: string) =>
  card_promotion_mechanics.includes(mechanic ?? '')